import React, { ReactElement, useState } from 'react';
import Button from 'modules/shared/components/inputs/Button';
import Form from 'modules/new-applications/components/application-sections/LimitAndApprovals/RevertDecision/Form';
import UserModel from 'models/UserModel';
import FixedContent from 'modules/shared/components/containers/FixedContent';
import { ButtonWrapper } from 'modules/new-applications/components/application-sections/LimitAndApprovals/RevertDecision/style';
import isBlank from 'utils/isBlank';

const RevertDecision = ({
  application,
  currentUser,
  onRevertDecisionCallback,
  onSetAlert,
}: {
  application: any;
  currentUser: UserModel;
  onRevertDecisionCallback: () => void;
  onSetAlert: () => void;
}): ReactElement | null => {
  if (
    isBlank(currentUser) ||
    currentUser.isStandard ||
    !application.canRevertDecision
  ) {
    return null;
  }

  const [isRevertFormVisible, setIsRevertFormVisible] = useState(false);

  if (isRevertFormVisible) {
    return (
      <Form
        application={application}
        currentUser={currentUser}
        onCloseForm={() => setIsRevertFormVisible(false)}
        onRevertDecisionCallback={onRevertDecisionCallback}
        onSetAlert={onSetAlert}
      />
    );
  }

  return (
    <FixedContent withBottomMargin={false}>
      <ButtonWrapper>
        <Button
          text="Revert decision"
          handleClick={() => setIsRevertFormVisible(true)}
        />
      </ButtonWrapper>
    </FixedContent>
  );
};

export default RevertDecision;
